import { render } from "./LogsAggs.vue?vue&type=template&id=7a063d39&scoped=true"
import script from "./LogsAggs.vue?vue&type=script&lang=js"
export * from "./LogsAggs.vue?vue&type=script&lang=js"

import "./LogsAggs.vue?vue&type=style&index=0&id=7a063d39&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a063d39"]])

export default __exports__